function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex items-center bg-back justify-center bg-opacity-70">
      <div className="w-12 h-12 border-4 border-blue-200 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}

export default Loading;
